import { Pipe, PipeTransform } from '@angular/core';
import { SupplyItem } from "../../scp/preferences/models";

@Pipe({
name: 'filterByCategoryCode'
})
export class FilterByCategoryCodePipe implements PipeTransform
{
    transform(items: SupplyItem[], code: string): SupplyItem [] {
        if (!items || !code)
        {
            return items;
        }

      const filt = items.filter(si => !si.rentalCategories || !si.rentalCategories.length || si.rentalCategories.filter(rc => rc.rentalCategory.code.startsWith(code)).length);

      /*const filt = items.filter(si => si.isSuppliedBySchool === false && si.rentalCategories.some(rc => rc.rentalCategory.code == code));*/
      return filt; 
    }
}
